export const fields = (label, getValidation) => {
  return {
    note: {
      label: label,
      rules: getValidation(),
    },
  };
};
